// removed by extract-text-webpack-plugin
module.exports = {"main":"main__main___eIVsn"};


//////////////////
// WEBPACK FOOTER
// ./study_coordinator/src/main.css
// module id = 652
// module chunks = 0